import React from 'react';

import { Container, Content, Button, Title, IconBack, IconClose, Spacer, RightButton } from './styles';

interface HeaderProps {
  title?: string;
  children?: JSX.Element | JSX.Element[];
  onClose?: () => void;
  goBack: () => void;
  buttonLabel?: string;
  rightButton?: JSX.Element | JSX.Element[];
}

const HeaderMobile = ({ title, onClose, goBack, children, buttonLabel, rightButton }: HeaderProps) => (
  <Container>
    <Content>
      <Button onClick={goBack}>
        <IconBack />
      </Button>
      {title !== undefined && <Title>{title}</Title>}
      {children}
      {rightButton ? (
        <>{rightButton}</>
      ) : buttonLabel ? (
        <RightButton onClick={onClose}>{buttonLabel}</RightButton>
      ) : onClose ? (
        <Button onClick={onClose}>
          <IconClose />
        </Button>
      ) : (
        <Spacer />
      )}
    </Content>
  </Container>
);

export default HeaderMobile;
